var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutLoose',[_c('Skeleton',{attrs:{"team_id":_vm.team_id,"organization_id":this.$route.meta.organization_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }